// This file is generated by a script and should not be modified directly.
const markdown: string = "Allow filtering job offers by opco name.\n"
export default markdown
